import { render, staticRenderFns } from "./InputFormOrder.vue?vue&type=template&id=58781d1e&"
import script from "./InputFormOrder.vue?vue&type=script&lang=ts&"
export * from "./InputFormOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports